import axios from "../../utils/axios";

export const postLike = async ({ id, likes }) => {
  const response = await axios.patch(`/blogs/${id}`, {
    likes: likes + 1,
  });

  return response.data.likes;
};
